import './index.scss';
import { Collapse, Dropdown, Modal, ScrollSpy, Tab, Tooltip, Popover } from 'bootstrap';

let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new Tooltip(tooltipTriggerEl, {trigger: 'hover'});
});
